window.lottieAnimations = window.lottieAnimations || [];
import lottie from 'lottie-web';
import { fetchJSONWithOfflineSupport } from './offlineJSON';

export function loadAnimations() {
    document.querySelectorAll('.animation-container').forEach(function(container) {
        var aniIcon = container.querySelector('.animation-icon');
        var aniIconId = aniIcon.getAttribute('id');
        var delayInSeconds = parseInt(aniIcon.getAttribute('data-delay'), 10) || 0;

        if (document.querySelector('#results-page').classList.contains('active')) {
            setTimeout(function() {
                const animationPath = '../_/js/animations/' + aniIconId + '.json';
                
                // Load JSON with offline support
                fetchJSONWithOfflineSupport(animationPath)
                    .then(animationData => {
                        const animation = lottie.loadAnimation({
                            container: aniIcon,
                            renderer: 'svg',
                            loop: false,
                            autoplay: true,
                            animationData: animationData
                        });
                        
                        // Store the animation instance
                        window.lottieAnimations.push(animation);
                        
                        animation.addEventListener('complete', function() {
                            // Find the text overlay and add the active class
                            let textOverlay = container.querySelector('.text-overlay');
                            let decimalPlace = textOverlay.dataset.decimal;
                            if (textOverlay) textOverlay.classList.add('active');
                            
                            countUp(container.querySelector('.countup'), decimalPlace);
                        });
                    })
                    .catch(error => {
                        console.error('Error loading animation:', error);
                        // Fallback to direct path if all else fails
                        const animation = lottie.loadAnimation({
                            container: aniIcon,
                            renderer: 'svg',
                            loop: false,
                            autoplay: true,
                            path: animationPath
                        });
                        
                        window.lottieAnimations.push(animation);
                        
                        animation.addEventListener('complete', function() {
                            let textOverlay = container.querySelector('.text-overlay');
                            let decimalPlace = textOverlay.dataset.decimal;
                            if (textOverlay) textOverlay.classList.add('active');
                            
                            countUp(container.querySelector('.countup'), decimalPlace);
                        });
                    });
            }, delayInSeconds * 1000);
        }
    });
}

function countUp(element, decimal = 2) {
    if (!element) return; 

    decimal = parseInt(decimal, 10);

    // Remove any currency symbols and commas before parsing
    let startText = element.textContent.replace(/[^0-9.-]+/g, '');
    let start = parseFloat(startText);
    let val = 0;
    let step = Math.abs(start) / 100; // Ensure step is always positive

    // Determine the formatting based on whether the value is negative or positive
    let currencySymbol = element.textContent.match(/[^0-9.-]+/g);
    currencySymbol = currencySymbol ? currencySymbol[0] : '';

    let counter = setInterval(() => {
        if ((start >= 0 && val < start) || (start < 0 && val > start)) {
            val += (start >= 0 ? step : -step); // Increment or decrement based on start value
            let displayValue = val.toFixed(decimal); // Use dynamic decimal places
            element.textContent = currencySymbol + parseFloat(displayValue).toLocaleString(undefined, { minimumFractionDigits: decimal, maximumFractionDigits: decimal });
        } else {
            // Ensure final text is properly formatted with the dynamic decimal places
            element.textContent = currencySymbol + parseFloat(start).toLocaleString(undefined, { minimumFractionDigits: decimal, maximumFractionDigits: decimal });
            element.classList.add('done');
            clearInterval(counter);
        }
    }, 20);
}

export function clearAnimations() {
    if (window.lottieAnimations) {
        window.lottieAnimations.forEach(animation => {
            animation.destroy();
        });
        // Clear the array after destroying the animations
        window.lottieAnimations = [];
    }
    document.querySelectorAll('.text-overlay.active').forEach(textOverlay => {
        textOverlay.classList.remove('active');
    });
}